/* ============================================================
   DEMO MODE

   `/demo/*` runs the real v2 app against an in-browser fake API
   (see `demo/server`). Decided once at boot from the URL; the
   router runs under the `/demo` basename, so in-app navigation
   never leaves it. Only hard redirects need `appPath()`.
   ============================================================ */

export const DEMO_BASE = '/demo';

const isDemoPath = (pathname: string): boolean =>
  pathname === DEMO_BASE || pathname.startsWith(`${DEMO_BASE}/`);

export const isDemoMode: boolean =
  typeof window !== 'undefined' && isDemoPath(window.location.pathname);

/** Prefix an app path for hard redirects (`window.location.href = ...`). */
export const appPath = (path: string): string => {
  if (!isDemoMode) return path;
  return path === '/' ? DEMO_BASE : `${DEMO_BASE}${path}`;
};
